import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon-help.png'
import _imports_1 from '../assets/score-empty.png'


const _withScopeId = n => (_pushScopeId("data-v-1ff54d31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "points-content" }
const _hoisted_2 = { class: "points-content-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "积分", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "积分的更新可能存在延误")
], -1))
const _hoisted_5 = { class: "points-content-list" }
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "score-empty"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无明细", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "rule-content"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. 积分于2018年1月1日开始计算，每消费一元积一分。生日月的首笔交易可享受双倍积分，生日多倍积分，赠分上限为10,000分。", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2. 会员交易积分自交易之日起（订单付款日期）的第12个月月底到期。", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 积分兑礼开放仅在规定日期内开放，活动具体结束日期可能存在变化，解释权归倩碧所有。", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4. 单次活动兑换礼品数量有限，兑完为止。", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5. 不同兑换活动中礼品类型、礼品等级、礼品内容和单一等级兑礼限制可能会发生变化，请以具体活动为准。", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6. 会员兑换成功后，我们会以模板消息的形式告知成功兑换礼品的用户。", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "7. 兑换订单提交后，系统将自动扣除相对应积分，因此不能取消及更改订单。", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "8. 商品使用过程中出现各类问题遵照倩碧商品通用条款处理。", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "9. 如用户未收到兑礼产品，需在兑礼成功后3个月内联系品牌，如超过申诉期限，则视为默认接收到兑礼产品，后续兑礼产品无法补发或退还积分。", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "10. 若遇到生日积分与其他积分奖励时，以高倍积分获取为准（例如生日积分为双倍积分会员积分为三倍积分，则以三倍积分为准，不做叠加）。", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "11. 倩碧拥有法律规定范围内的所有解释权。", -1))
const _hoisted_23 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "rule-content"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "会员可使用有效消费积分进行登记积分兑换，互动积分需在入会规则中的指定渠道购买后激活积分后，开启兑换权益。", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. 所有礼品以悦木之源届时提供的实物为准，如缺货，悦木之源有权以同等价值礼品替换。", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2. 积分可分不同会员级别进行兑换，兑换的礼品数量有限，先到先得，兑完即止。", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 积分一经兑换，所兑礼品无法退换。积分一经使用，无法返还。", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4. 兑换礼品将由快递形式配送，当月申领礼品，将于次月月底前配送，预估邮寄时间50天，会员等级悦球人邮费300积分，会员等级超级悦球人包邮。", -1))
const _hoisted_30 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]

import { ref, onMounted, onActivated } from 'vue';
    import { useRouter } from "vue-router";
    import { useStore } from 'vuex';
    import { pointsDetailsList } from '@/server/api';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PointsDetails',
  setup(__props) {

    const $router = useRouter();
    const store = useStore();
    const loading = ref(false);
    const finished = ref(false);
    const showPopUp=ref(false);
    let list: number[] = [];
    const currentState = ref('');
    const currentStateUrl = ref('');
    const page = ref(1);
    const pageSize = ref(20);
    const totalScore = ref(0);
    const finishedText = ref('');

    onActivated(() => {
        totalScore.value = Number($router.currentRoute.value.query?.totalScore);
        currentState.value = store.state.currentState as string;
    })

    onMounted(() => {
        // currentState.value = store.state.currentState as string;
    })

    const getPointsDetails = async() => {
        const params = {
            userId: store.state.openId || window.localStorage.getItem('openId'),
            page: page.value,
            pageSize: pageSize.value
        }
        const { data } = await pointsDetailsList(params);
        list = list.concat(data);

        // 加载状态结束
        loading.value = false;

        // 数据全部加载完成
        if (list.length < 20) {
          finished.value = true;
          finishedText.value = '- 已显示全部 -';
        }
    }

    const onLoad = () => {
      setTimeout(() => {
        getPointsDetails();
        page.value = page.value + 1;
      }, 1000);
    };



return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['points',currentState.value === 'origins' ? 'origins' : '' ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showPopUp.value=true)),
            src: _imports_0
          }),
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPopUp.value=true))
          }, "积分规则")
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(totalScore.value), 1),
          _hoisted_3
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": finishedText.value,
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "point-list",
                key: item,
                title: item
              }, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", null, _toDisplayString(item.adjustmentType), 1),
                  _createElementVNode("span", null, _toDisplayString(item.createTime), 1)
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass(['add-points', item.availablePoints < 0 ? 'reduce-points' : ''])
                }, _toDisplayString(item.availablePoints < 0 ? item.availablePoints : '+' + item.availablePoints), 3)
              ], 8, _hoisted_6))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "finished-text"]),
        (_unref(list).length === 0 && finished.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_van_popup, {
      class: "vanpop",
      show: showPopUp.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showPopUp).value = $event)),
      style: { width: '84%', height: '65%' },
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(currentState.value === 'clinique' ? '积分规则' : '兑换须知'), 1),
        (currentState.value === 'clinique')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_23))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_30))
      ]),
      _: 1
    }, 8, ["show"])
  ], 2))
}
}

})